export enum SettleType {
  TEST = 'TEST',
  PROD = 'PROD'
}

export const SETTLE_TYPE = {
  [SettleType.TEST]: '테스트용',
  [SettleType.PROD]: '운영용'
};

export enum SettleInvoiceStatusType {
  OPENED = 'OPENED',
  ADJUSTMENT_REQUESTED = 'ADJUSTMENT_REQUESTED',
  ADJUSTMENT_IN_PROGRESS = 'ADJUSTMENT_IN_PROGRESS',
  CONFIRMED = 'CONFIRMED'
}

export const SETTLE_INVOICE_STATUS_TYPE = {
  [SettleInvoiceStatusType.OPENED]: '오픈',
  [SettleInvoiceStatusType.ADJUSTMENT_REQUESTED]: '조정요청',
  [SettleInvoiceStatusType.ADJUSTMENT_IN_PROGRESS]: '조정중',
  [SettleInvoiceStatusType.CONFIRMED]: '확정'
};

export enum SettleUnitType {
  DEALER = 'DEALER',
  PARTNER = 'PARTNER',
  SETTLE = 'SETTLE'
}

export enum SettleIssuancePeriodType {
  NONE = 'NONE',
  MONTHLY = 'MONTHLY',
  QUARTERLY = 'QUARTERLY',
  SEMIANNUALLY = 'SEMIANNUALLY',
  ANNUALLY = 'ANNUALLY'
}

export const SETTLE_ISSUANCE_PERIOD_TYPE = {
  [SettleIssuancePeriodType.NONE]: '대상아님',
  [SettleIssuancePeriodType.MONTHLY]: '월',
  [SettleIssuancePeriodType.QUARTERLY]: '분기',
  [SettleIssuancePeriodType.SEMIANNUALLY]: '반기',
  [SettleIssuancePeriodType.ANNUALLY]: '연'
};
